import { Grid, Box, Container } from '@material-ui/core'
import { MetricCard } from './components/MetricCard'
import { RevenueCard } from './components/RevenueCard'
import { GoalCard } from './components/GoalCard'
import { DaySoldCard } from './components/DaySoldCard'
import { HeaderCardsProps } from './types'

export const HeaderCards = ({storesReport, lastYearReport}: HeaderCardsProps) => {
  const variation = lastYearReport?.period.variation
  const variationAverages = variation?.averages

  return (
    <Container maxWidth={false} style={{ padding: 16 }}>
      <Grid container spacing={2} style={{ paddingTop: 8 }}>
        <Grid item lg={4} md={4} sm={6} xs={12}>
          <DaySoldCard
            daySoldValue={storesReport?.daySold.sold}
            dayGoalValue={storesReport?.dayGoals.sell}
          />
        </Grid>

        <Grid item lg={4} md={4} sm={6} xs={12}>
          <RevenueCard
            value={storesReport?.total.sold}
            lastYearPercentage={variation?.sold}
            projectionValue={storesReport?.total.projection.sold}
          />
        </Grid>

        <Grid item lg={4} md={4} sm={12} xs={12}>
          <Box
            display="flex"
            flexDirection="column"
            height="100%"
          >
            <Box mb={1}>
              <GoalCard
                title="META IDEAL"
                value={storesReport?.total.sold}
                expectedValue={storesReport?.total.metric.acDayGoal}
              />
            </Box>

            <GoalCard
              title="META DO MÊS"
              value={storesReport?.total.sold}
              expectedValue={storesReport?.total.metric.mainGoal}
            />
          </Box>
        </Grid>
      </Grid>

      <Grid container spacing={1} style={{ marginTop: '16px' }}>
        <Grid item lg={true} md={true} sm={12} xs={12}>
          <MetricCard
            title="TICKET MÉDIO"
            value={storesReport?.average.tm}
            expectedValue={storesReport?.total.metric.tm}
            lastYearPercentage={variationAverages?.tm}
          />
        </Grid>

        <Grid item lg={true} md={true} sm={12} xs={12}>
          <MetricCard
            title="PREÇO MÉDIO"
            value={storesReport?.average.pm}
            expectedValue={storesReport?.total.metric.pm}
            lastYearPercentage={variationAverages?.pm}
          />
        </Grid>

        <Grid item lg={true} md={true} sm={12} xs={12}>
          <MetricCard
            title="Nº VENDAS"
            format="integer"
            value={storesReport?.total.sales}
            expectedValue={storesReport?.total.metric.sales}
            lastYearPercentage={variation?.total}
          />
        </Grid>

        <Grid item lg={true} md={true} sm={12} xs={12}>
          <MetricCard
            title="PEÇAS / VENDA"
            format="decimal"
            value={storesReport?.average.pv}
            expectedValue={storesReport?.total.metric.pv}
            lastYearPercentage={variationAverages?.pv}
          />
        </Grid>

        <Grid item lg={true} md={true} sm={12} xs={12}>
          <MetricCard
            title="Nº PEÇAS"
            format="integer"
            value={storesReport?.total.items}
            expectedValue={storesReport?.total.metric.items}
            lastYearPercentage={variation?.items}
          />
        </Grid>
      </Grid>
    </Container>
  )
}
